import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScriptHeader } from '../styles';
import { Line } from '@slides/styles';

export const SectionThree = ({ details }) => {
    const { t } = useTranslation();
    const { 
        totalPayment, 
        avgMonthlyInterest, 
        totalMonthlyInterest, 
        percentPaidInInterest } = details;

    return (
        <>
            <div>
                {t('your_analysis.script.15')}
                <strong>
                    {t('your_analysis.script.16')}
                </strong>
                {t('your_analysis.script.17')}
                <strong>
                    {avgMonthlyInterest}
                </strong>
                {t('your_analysis.script.18')}
                <strong>{totalPayment}</strong>
                {t('your_analysis.script.19')}
                <p>
                    {t('your_analysis.script.20')}
                    <strong>{totalMonthlyInterest}</strong>
                    {t('your_analysis.script.21')}
                    <strong>{totalPayment}</strong>
                    <span>, </span>
                    <strong>{percentPaidInInterest}</strong>
                    {t('your_analysis.script.22')}
                    <strong>{t('your_analysis.script.23')}</strong>
                    {t('your_analysis.script.24')}
                </p>
            </div>
        </>
    );
};